// 更多规则可查看 https://github.com/any86/any-rule

/**
 * 验证手机号
 * @param {string} str
 * @returns {Boolean}
 */
export function checkPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

/**
 * 验证6位手机验证码
 * @param {string} str
 * @returns {Boolean}
 */
export function check6Code(code) {
  return /^\d{6}$/.test(code);
}
